export default function RangeInput({title, min, max, value, register, name, metricSystem=" кв.м", handleInputChange}) {

    if (!max) return null
    return (
        <div className="filter-range">
            <div className="filter-range__name">{title}</div>
            <div className="filter-range__box">
                <input
                    min={min}
                    max={max}
                    defaultValue={max}
                    className="filter-range__range"
                    type="range"
                    step="0.1"
                    name="square"
                    id="square"
                    {...register(name)}
                    onInput={(e) => handleInputChange(e.target.value)}
                />
            </div>
            <div className="filter-range__value">
                <p data-before className="filter-range__before">
                    от <span>{min}</span>{metricSystem}
                </p>
                <p data-after className="filter-range__after">
                    до <span>{value === 0 ? max : value}</span>{metricSystem}
                </p>
            </div>
        </div>
    );
}
